<template>
	<section class="wrapper">
		<div class="main">
			<h2>兑换激活码</h2>
			<div>
				<p>使用说明</p>
				<p>1.每一个激活码只可激活一次</p>
				<p>2.本激活码兑换入口可用于兑换锦田云手机服务</p>
				<p>3.通过非官方渠道获得的激活码，如出现相关问题，云锦概不负责</p>
				<p>4.云锦对激活码功能拥有最终解释权</p>
				<p>5.云机激活码有效期：永久</p>
			</div>
			<el-input v-model="state.textarea_value" type="textarea" :placeholder="state.textarea_placeholder" />
			<div style="margin-top: 10px;">
				<el-button v-if="state.activate_Cate_data"
					@click="Get_android_brand_model">选择安卓版本和机型</el-button>
					<span style="margin-left: 20px;">tips:每次重新输入或者添加激活码后请先<span style="color: #169bd5;">点击左侧</span>按钮</span>
			</div>
			<div style="margin-top: 20px;">
				<el-radio-group style="margin-right: 20px;" v-if="state.activate_Cate_data['1']" v-model="state.game_phone_android"
					@change="Get_android_brand_model">
					<el-radio style="background-color: #ffffff;" v-for="item in state.game_android_list" :key="item"
						border :value="item">
						Android {{ item }}
					</el-radio>
				</el-radio-group>
				<el-radio-group v-if="state.activate_Cate_data['2']" v-model="state.current_android"
					@change="Get_android_brand_model">
					<el-radio style="background-color: #ffffff;" v-for="item in state.android_list" :key="item" border
						:value="item">
						Android {{ item }}
					</el-radio>
				</el-radio-group>
			</div>
			<div v-if="state.activate_Cate_data['2']">
				<h3>产品品牌</h3>
				<div class="phone-brands-box">
					<div v-for="(item,index) in state.phone_brands" :key="item.brand">
						<el-button plain :class="state.activeBrand==item.brand?'phone_type_btn_checked':''"
							@click="change_phone_type(item)">{{item.brand}}</el-button>
					</div>
				</div>
				<h3>云机机型</h3>
				<el-radio-group class="has-gap" v-model="state.selectedModel">
					<el-radio style="background-color: #ffffff;margin-top: 10px;"
						v-for="item in state.phone_brand_models" :key="item.id" border :label="item.model"
						:value="item.id">{{ item.model }}
					</el-radio>
				</el-radio-group>
			</div>
			<div style="width: 100%;text-align: right;margin-top: 20px;">
				<el-button type="primary" class="Activation-btn" @click="activation_phone">兑换</el-button>
			</div>
		</div>
	</section>
</template>

<script setup>
	import {
		ref,
		reactive,
		computed,
		onMounted,
		onUnmounted,
		nextTick,
		watch,
	} from 'vue';
	import request from '@/utils'
	import {
		ElMessage,
		ElMessageBox,
		ElLoading,
		ElIcon
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	const store = useStore();
	const activation_code_arr = []
	const state = reactive({
		textarea_placeholder: "允许批量输入激活码,每行一个激活码\nJLTGVYU7OKFD\nJLTGVYU7OKFD",
		textarea_value: '',
		current_android: 0, //云真机当前安卓版本
		game_android_list: [10], //游戏型安卓版本数组
		android_list: [13, 14, 15], //云真机安卓版本数组
		game_phone_android: 0, //游戏机安卓版本是否选中
		activate_Cate_data: [], //安卓列表版本数据
		phone_brands: [],
		phone_brand_models: [],
		activeBrand: null,
		selectedModel: null,
		request_activation_phone_value: []
	})

	// 根据激活码获取安卓版本列表
	const Get_android_brand_model = () => {
		if (!state.textarea_value) {
			ElMessage.error('请先输入激活码');
			return;
		}
		const requestData = {
			code: state.textarea_value.split('\n')
		};
		request.post('/activate/get_activate_cate', requestData, {
			customHandle: true
		}).then((res) => {
			state.activate_Cate_data = res.data.data
			if(res.data.data['1']){
				state.game_android_list = res.data.data['1'].AndroidVersion
				state.game_phone_android = res.data.data['1'].AndroidVersion[0]
			}
			if (res.data.data['2']) {
				state.current_android = res.data.data['2'].AndroidVersion[0]
				const response = request.get('/realphone/list?android_version=' + state.current_android)
				response.then((req) => {
					state.phone_brands = req.data.data
					state.phone_brand_models = req.data.data[0].models
					state.activeBrand = req.data.data[0].brand
					state.selectedModel = req.data.data[0].models[0].id;
					state.android_list = res.data.data['2'].AndroidVersion
					activation_code_arr.value = JSON.parse(JSON.stringify(state.textarea_value.split(
						'\n')))
				}).catch(() => {})
			}
		}).catch((error) => {
			ElMessage.error(error.response?.data?.msg || '激活码输入错误');
		})
	}
	//品牌数据更换
	const change_phone_type = (item) => {
		state.activeBrand = item.brand
		state.selectedModel = item.models[0].id;
		state.phone_brand_models = item.models
	}
	//选择的机型
	const selectModel = (id) => {
		state.selectedModel = id;
	}
	//兑换云机
	const activation_phone = async () => {
		const isValid = await filter_Activate_Cate(state.activate_Cate_data)
		console.log(isValid);
		if (!isValid) {
			return;
		}
		await request.post('/activate/exchange_activate_code', state.request_activation_phone_value, {
			customHandle: true
		}).then((res) => {
			if (res.data.code === 200) {
				ElMessage.success('激活码兑换成功');
			}
		}).catch((error) => {
			ElMessage.error(error.response?.data?.msg || '兑换激活码失败');
		})
	}

	function filter_Activate_Cate(data) {
		state.request_activation_phone_value = []
		if (data['1']) {
			if (!state.game_phone_android) {
				ElMessage.error('请先选择安卓版本');
				return false;
			}
			data['1'].ActivateCodes.forEach((item, index) => {
				state.request_activation_phone_value.push({
					"code": item.code,
					"android_version": state.game_phone_android,
					"realphone_template_id": null, //真机模板id
					"proxy_id": null
				})
			})
		}
		if (data['2']) {
			if (!state.current_android) {
				ElMessage.error('请先选择安卓版本');
				return false;
			}
			data['2'].ActivateCodes.forEach((item, index) => {
				state.request_activation_phone_value.push({
					"code": item.code,
					"android_version": state.current_android,
					"realphone_template_id": state.selectedModel, //真机模板id
					"proxy_id": null
				})
			})
		}
		return true;
	}
</script>

<style lang="less" scoped>
	.wrapper {
		background-color: #f0fafe;
		border-radius: 10px;
		position: relative;
		padding: 20px;
		box-sizing: border-box;

		.main {
			text-align: left;

			p {
				margin: 20px 0;
			}

			.Activation-btn {
				padding: 20px 40px;
			}

			:deep(.el-textarea__inner) {
				width: 100%;
				height: 24vh;
				background-color: #fff;
				border: 1px solid #ddd;
				padding: 10px;
				box-sizing: border-box;
				border-radius: 6px;
				resize: none !important;
			}

			.phone-brands-box {
				display: flex;
				gap: 10px;

				.el-button.is-plain:hover {
					color: #0079f2;
					border-color: #0079f2;
				}
			}
		}
	}

	.phone_type_btn_checked {
		color: #0079f2;
		border-color: #0079f2;
	}
</style>